// meta-frentista-a2 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "%{n} abastecimentos por dia": "%{n} abastecimientos por día",
    "%{n}% de fidelização": "%{n}% de fidelización",
    "60 dias grátis": "60 días gratis",
    "A meta foi atualizada com os dados desta semana": "El objetivo se actualizó con los datos de esta semana",
    "Agora não": "Ahora no",
    "Conservadora": "Conservadora",
    "Degustação encerrada": "Degustación finalizada",
    "Degustação: falta 1 dia": "Degustación: falta 1 día",
    "Degustação: faltam %{n} dias": "Degustación: faltan %{n} días",
    "Desafiadora": "Desafiante",
    "Encontramos oportunidades de acompanhar melhor a produtividade da sua equipe. Veja a meta pronta e teste 60 dias grátis.": "Encontramos oportunidades de seguir mejor la productividad de su equipo. Vea el objetivo listo y pruebe 60 días gratis.",
    "Equilibrada": "Equilibrada",
    "Esta leitura não está disponível para o estado atual do convite.": "Esta lectura no está disponible para el estado actual de la invitación.",
    "Este convite não está mais disponível.": "Esta invitación ya no está disponible.",
    "Meta de Frentista com IA": "Objetivo del Playero con IA",
    "Nenhum posto da sugestão está ativo na rede.": "Ninguna estación de la sugerencia está activa en la red.",
    "Não foi possível concluir. Tente novamente.": "No fue posible completar. Inténtelo de nuevo.",
    "Não foi possível criar a meta em um dos postos. Nada foi ativado; tente novamente.": "No fue posible crear el objetivo en una de las estaciones. No se activó nada; inténtelo de nuevo.",
    "O módulo Meta de Frentista está desativado.": "El módulo Objetivo del Playero está desactivado.",
    "O módulo Meta de Frentista já está ativo na sua rede.": "El módulo Objetivo del Playero ya está activo en su red.",
    "O pedido para continuar não está disponível agora.": "La solicitud para continuar no está disponible ahora.",
    "Os níveis escolhidos não conferem com os postos da sugestão. Recarregue a página.": "Los niveles elegidos no coinciden con las estaciones de la sugerencia. Recargue la página.",
    "Para continuar depois, tem desconto especial": "Para continuar después, hay un descuento especial",
    "Quero continuar com desconto": "Quiero continuar con descuento",
    "Recebemos seu pedido": "Recibimos su solicitud",
    "Sua degustação está em andamento. Acompanhe a produtividade da equipe pelo quadro de metas.": "Su degustación está en curso. Siga la productividad del equipo en el tablero de objetivos.",
    "Sua degustação terminou. Veja o antes e o depois da produtividade da equipe.": "Su degustación terminó. Vea el antes y el después de la productividad del equipo.",
    "Só o usuário da rede pode fazer isso.": "Solo el usuario de la red puede hacer esto.",
    "Ver minha meta pronta": "Ver mi objetivo listo",
    "Ver resultado final": "Ver resultado final",
    "Ver resultados": "Ver resultados",
    "frentistas a acompanhar": "playeros a acompañar",
    "frentistas a acompanhar na fidelização": "playeros a acompañar en la fidelización",
    "postos com oportunidade": "estaciones con oportunidad",
};

export default catalogo;
